export const generateId = () => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for ( var i = 0; i < 5; i++ ) result += characters.charAt(Math.floor(Math.random() * charactersLength))
  return result
}

// STY-695: the published post is generated from this shape. For each section
// the blog builder (smp_post_from_submission_2, since STY-668) emits every
// image set first and then the section's copy, so the order of a built
// real-wedding post is:
//
//   lead image, opening,
//   Getting Ready, THE PLANNING copy,
//   Invitations & Flatlays, Bridal Portraits, Wedding Party, THE FASHION copy,
//   Ceremony, Cocktail Hour, Reception, Wedding Cake, More Details,
//   Happy Couple, Wedding Weekend Events, THE DETAILS copy
//
// Which section an image set sits under therefore decides where it lands
// relative to the three text blocks, not what it is about. This is copied into
// a submission's blob when the submission is created and never re-read, so a
// change here only reaches new submissions; smp_blog/scripts/
// migrate-real-wedding-image-sets.php carries it to submissions already in
// flight. Keep the two in step.
export const defaultSectionData = [
  {
    type: 'real-wedding',
    sections: [
      {
        name: 'The Planning',
        fields: [
          {name: 'Wedding Colors', 'text': '', type: 'Required'},
          {name: 'Design / Vibe / Vision', 'text': '', type: 'Required'},
          {name: 'Proposal Story', 'text': '', type: 'Highly Encouraged'}
        ],
        images: [
          {name: 'Getting Ready', carousel: true, images: []}
        ]
      }, {
        name: 'The Fashion',
        fields: [
          {name: 'Wedding Gown', 'text': '', type: 'Highly Encouraged'},
          {name: 'Bridesmaid Dresses', 'text': '', type: 'Highly Encouraged'},
          {name: 'Groomsman Attire', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Invitations & Flatlays', carousel: true, images: []},
          {name: 'Bridal Portraits', carousel: true, images: []},
          {name: 'Wedding Party', carousel: true, images: []}
        ]
      }, {
        name: 'The Details',
        fields: [
          {name: 'Food & Drink', 'text': '', type: 'Required'},
          {name: 'Florals & Decor', 'text': '', type: 'Required'},
          {name: 'Wedding Cake', 'text': '', type: 'Required'},
          {name: 'Readings, Ceremony Music, Reception Songs', 'text': '', type: 'Optional'},
          {name: 'Special Detail #1', 'text': '', type: 'Optional'},
          {name: 'Special Detail #2', 'text': '', type: 'Optional'},
          {name: 'Special Detail #3', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Ceremony', carousel: true, images: []},
          {name: 'Cocktail Hour', carousel: true, images: []},
          {name: 'Reception', carousel: true, images: []},
          {name: 'Wedding Cake', carousel: true, images: []},
          {name: 'More Details', carousel: true, images: []},
          {name: 'Happy Couple', carousel: true, images: []},
          {name: 'Wedding Weekend Events', carousel: true, images: []}
        ]
      }
    ],
    title: 'Wedding Details',
    subtitle: 'Please fill in as many of the wedding details as possible. If picked for publication, we will use these details to create a full, robust story that our audience can quickly and easily peruse.'
  }, {
    type: 'engagement',
    sections: [
      {
        name: 'The Details',
        fields : [
          {name: 'Proposal Story', 'text': '', type: 'Required'},
          {name: 'Shoot Location', 'text': '', type: 'Required'},
          {name: 'Design / Vibe / Vision', 'text': '', type: 'Required'},
          {name: 'Outfit Details', 'text': '', type: 'Highly Ecouraged'},
          {name: 'Overall Style', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Our Favorites', carousel: true, images: []}
        ]
      }
    ],
    title: 'Engagement Details',
    subtitle: 'Please fill in as many of the engagement details as possible. If picked for publication, we will use these details to create a full, robust story that our audience can quickly and easily peruse.'
  }, {
    type: 'inspiration-shoot',
    sections: [
      {
        name: 'The Planning',
        fields : [
          {name: 'The Inspiration', 'text': '', type: 'Required'},
          {name: 'Wedding Colors', 'text': '', type: 'Required'},
          {name: 'The Venue', 'text': '', type: 'Required'}
        ],
        images: [
          {name: 'Beauty', carousel: true, images: []},
          {name: 'Flat Lays', carousel: true, images: []}
        ]
      }, {
        name: 'The Fashion',
        fields: [
          {name: 'Wedding Gown', 'text': '', type: 'Highly Ecouraged'},
          {name: 'Wedding Party', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Bridal Portraits', carousel: true, images: []},
          {name: 'Fashion', carousel: true, images: []}
        ]
      }, {
        name: 'The Details',
        fields: [
          {name: 'Florals & Decor', 'text': '', type: 'Required'},
          {name: 'Favorite Design Element', 'text': '', type: 'Highly Ecouraged'},
          {name: 'Tips To Pull Off The Look', 'text': '', type: 'Highly Ecouraged'},
          {name: 'DIY Moments', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Details', carousel: true, images: []},
          {name: 'Couple Portraits', carousel: true, images: []}
        ]
      }
    ],
    title: 'Styled Shoot',
    subtitle: 'Please fill in as many of the details as possible. If picked for publication, we will use these details to create a full, robust story that our audience can quickly and easily peruse.'
  }, {
    type: 'workshop',
    sections: [
      {
        name: 'The Planning',
        fields : [
          {name: 'The Inspiration', 'text': '', type: 'Required'},
          {name: 'Wedding Colors', 'text': '', type: 'Required'},
          {name: 'The Venue', 'text': '', type: 'Required'}
        ],
        images: [
          {name: 'Beauty', carousel: true, images: []},
          {name: 'Flat Lays', carousel: true, images: []}
        ]
      }, {
        name: 'The Fashion',
        fields: [
          {name: 'Wedding Gown', 'text': '', type: 'Highly Ecouraged'},
          {name: 'Wedding Party', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Bridal Portraits', carousel: true, images: []},
          {name: 'Fashion', carousel: true, images: []}
        ]
      }, {
        name: 'The Details',
        fields: [
          {name: 'Florals & Decor', 'text': '', type: 'Required'},
          {name: 'Favorite Design Element', 'text': '', type: 'Highly Ecouraged'},
          {name: 'Tips To Pull Off The Look', 'text': '', type: 'Highly Ecouraged'},
          {name: 'DIY Moments', 'text': '', type: 'Optional'}
        ],
        images: [
          {name: 'Details', carousel: true, images: []},
          {name: 'Couple Portraits', carousel: true, images: []}
        ]
      }
    ],
    title: 'Workshop',
    subtitle: 'Please fill in as many of the details as possible. If picked for publication, we will use these details to create a full, robust story that our audience can quickly and easily peruse.'
  }
]